import React from 'react';
import Link from 'gatsby-link'

import '../styles/indexPage.scss'

export default () =>
  <div className="item-container">

    <div className="course-item-container">
      <span className="new-label">New</span>
      <a href="https://flexbox.io/friend/YONGZHI">
        <div className="image-container">
          <img src="https://www.penta-code.com/wp-content/uploads/2018/04/flexbox20free.png" />
        </div>
        <div className="course-title">Learn Flexbox </div>
      </a>
    </div>

    <div className="course-item-container">
      <span className="new-label">New</span>
      <a href="https://CSSGrid.io/friend/YONGZHI">
        <div className="image-container">
          <img src="https://www.penta-code.com/wp-content/uploads/2018/04/Learn-CSS-Grid.png" />
        </div>
        <div className="course-title">CSS Grid</div>
      </a>
    </div>

    <div className="course-item-container">
      <span className="new-label">FREE</span>
      <a href="https://LearnRedux.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://i.imgur.com/g6aGvkE.png" />
        </div>
        <div className="course-title">Learn Redux</div>
      </a>
    </div>

    <div className="course-item-container">
      <a href="https://ReactForBeginners.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://i.imgur.com/cvbhVQt.jpg" />
        </div>
        <div className="course-title">ReactJS For Beginners</div>
      </a>
    </div>

    <div className="course-item-container">
      <a href="https://es6.io/friend/YONGZHI">
        <div className="image-container">
          <img src="https://i.imgur.com/2AIkoVb.png" />
        </div>
        <div className="course-title">ES6 For Everyone</div>
      </a>
    </div>

    <div className="course-item-container">
      <a href="https://LearnNode.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://www.penta-code.com/wp-content/uploads/2018/04/learnnodeAD.png" />
        </div>
        <div className="course-title">Learn Node</div>
      </a>
    </div>

    <div className="course-item-container">
      <span className="new-label">FREE</span>
    
      <a href="https://JavaScript30.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://www.penta-code.com/wp-content/uploads/2018/04/Javascript30days.png" />
        </div>
        <div className="course-title">30 Day JS Coding Challenge</div>
      </a>
    </div>

    <div className="course-item-container">
      <a href="https://CommandLinePowerUser.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://i.imgur.com/6aTCf3T.png" />
        </div>
        <div className="course-title">Command Line Power User</div>
      </a>
    </div>

    <div className="course-item-container">
      <a href="https://SublimeTextBook.com/friend/YONGZHI">
        <div className="image-container">
          <img src="https://i.imgur.com/FSkXQpE.png" />
        </div>
        <div className="course-title">Sublime Text Power User</div>
      </a>
    </div>

  </div>


// WEBPACK FOOTER //
// ./src/pages/index.js